import React from "react";
import { BadgeCheck } from "lucide-react";

/**
 * Yellow tick badge shown next to verified seller / business / recruiter
 * names. Variants: `inline` (default, used in body text) and `corner`
 * (small icon-only, used in cards and avatar overlays).
 */
export default function VerifiedBadge({ variant = "inline", className = "" }) {
    if (variant === "corner") {
        return (
            <span
                data-testid="verified-badge"
                title="Verified by Adukoo"
                className={`inline-flex items-center justify-center w-5 h-5 rounded-full bg-aduku-yellow text-aduku-navy shadow-sm ${className}`}
            >
                <BadgeCheck className="w-3.5 h-3.5" strokeWidth={2.5} />
            </span>
        );
    }
    return (
        <span
            data-testid="verified-badge"
            title="Verified by Adukoo"
            className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-aduku-yellow/25 text-aduku-navy text-[10px] font-bold uppercase tracking-wider border border-aduku-yellow/60 ${className}`}
        >
            <BadgeCheck className="w-3 h-3" strokeWidth={2.5} /> Verified
        </span>
    );
}
